import jQuery from "jquery";

const $ = jQuery;

const coBrandCardHeroSection = (($) => { // eslint-disable-line

  const me = {};
  const $pageSubNav = $('.page-sub-nav');
  const $enableSticky = $('.enable-link-sticky').length === 1;
  let wScrollBefore = 0;

  const removeStickyButton = () => {

    $('.apply-link-sticky').removeClass('button--sticky');
    $('.apply-link-sticky').css('display', 'none');
    $('.apply-link').css('opacity', '1');

  };

  const addStickyButton = () => {

    $('.apply-link').css('opacity', '0');
    $('.apply-link-sticky').addClass('button--sticky');
    $('.apply-link-sticky').css('display', 'inline-block');

  };

  const makeSticky = () => {
    const applyLink = $('.apply-link');
    if (!applyLink.length) {
        return;
    }    

    const scrollPosition = $(window).scrollTop();
    const applyLinkButtonOffsetTop = applyLink.offset().top;
    let applyButtonMargin = applyLinkButtonOffsetTop - 10;

    if ($pageSubNav.length === 1) {

      const elHeight = $pageSubNav.outerHeight();
      const dHeight = $('body').height();
      const wHeight = $(window).height();

      if (scrollPosition > wScrollBefore) {

        // Down scroll
        if (scrollPosition + wHeight >= dHeight - elHeight) {

          // Scrolled to bottom of page
          $('.apply-link-sticky').css('top', '60px');
          applyButtonMargin = applyLinkButtonOffsetTop - 60;

        } else {

          $('.apply-link-sticky').css('top', '10px');

        }

      } else {

        // Scroll upp
        $('.apply-link-sticky').css('top', '60px');
        applyButtonMargin = applyLinkButtonOffsetTop - 60;

      }

    }

    wScrollBefore = scrollPosition;

    if ($(window).width() < 1009) {

      if (applyButtonMargin > scrollPosition) {

        removeStickyButton();

      } else {

        addStickyButton();

      }

    } else {

      removeStickyButton();

    }

  };

  me.init = function() {

    if ($enableSticky) {

      $(window).on('load', () => {

        makeSticky();

      });

      $(window).on('scroll resize', () => {

        makeSticky();

      });

    }

  };

  return me;

})(jQuery); // eslint-disable-line

export default coBrandCardHeroSection;
